<template>
  <div class="relative">
    <!-- Slide Menus -->
    <FrontendLayoutHeaderMobileNestedMenu
      v-model:isOpen="uiStore.menuSlide"
      :menu="props.categories"
    />
    <LazyFrontendLayoutHeaderSlideAccount v-model="uiStore.accountSlide" />
    <LazyFrontendLayoutHeaderSlideCart v-model="uiStore.cartSlide" />
    <LazyFrontendLayoutHeaderSearchInput v-if="mainStore.isOpenSearch" />

    <!-- Main Content -->
    <div class="container mx-auto px-4 py-3">
      <div class="flex items-center justify-between">
        <!-- Left Actions -->
        <div class="flex items-center gap-2">
          <button
            @click="toggleSlide('menuSlide')"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-slate-50/80 hover:bg-slate-100 transition-all active:scale-95"
          >
            <UIcon name="i-heroicons-bars-3" class="w-5 h-5 text-slate-700" />
          </button>
          <button
            @click="mainStore.isOpenSearch = true"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-slate-50/80 hover:bg-slate-100 transition-all active:scale-95"
          >
            <UIcon
              name="i-heroicons-magnifying-glass"
              class="w-5 h-5 text-slate-700"
            />
          </button>
        </div>

        <!-- Logo -->
        <NuxtLink
          href="/"
          class="transform hover:scale-105 transition-transform"
        >
          <img
            :src="logoSrc"
            class="w-[100px] h-auto"
            format="webp"
            height="40"
            alt="Logo"
          />
        </NuxtLink>

        <!-- Right Actions -->
        <div class="flex items-center gap-2">
          <button
            @click="toggleSlide('accountSlide')"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-slate-50/80 hover:bg-slate-100 transition-all active:scale-95"
          >
            <UIcon
              name="i-heroicons-user-circle"
              class="w-5 h-5 text-slate-700"
            />
          </button>

          <button
            @click="toggleSlide('cartSlide')"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-slate-50/80 hover:bg-slate-100 transition-all active:scale-95 relative"
          >
            <UIcon
              name="i-heroicons-shopping-bag"
              class="w-5 h-5 text-slate-700"
            />
            <span
              v-if="props.cart?.totalItems > 0"
              class="absolute -bottom-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-[11px] font-semibold bg-orange-500 text-white rounded-full shadow-sm"
              >{{ cartBadgeLabel }}</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  },
  cart: {
    type: Object,
    default: () => ({
      cartQyt: 0,
      cartTotalAmount: 0
    })
  }
})

const siteSettings = useSiteSettingsStore()
const logoSrc = computed(() => siteSettings.logoUrl)
const mainStore = useMainStore()
const uiStore = useUiStore()
const cartBadgeLabel = computed(() => {
  const quantity = Number(props.cart?.totalItems ?? 0)
  if (quantity > 99) {
    return '99+'
  }
  if (quantity > 9) {
    return '9+'
  }
  return quantity
})

// Slide toggle işlevi
const toggleSlide = (slideKey) => {
  // Diğer tüm slide'ları kapatt
  Object.keys(uiStore.$state).forEach((key) => {
    if (key !== slideKey && key.endsWith('Slide')) {
      uiStore[key] = false
    }
  })
  // İlgili slide'ı aç/kapat
  uiStore[slideKey] = !uiStore[slideKey]
}
</script>
